var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "printingUploadDialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传",
            visible: _vm.printingUploadDialog,
            width: "50%",
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.printingUploadDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: { model: _vm.ruleForm, "label-width": "100px" },
            },
            [
              _c("el-form-item", { attrs: { label: "设计稿", prop: "file" } }, [
                _c(
                  "div",
                  { staticStyle: { position: "relative" } },
                  [
                    _c("span", { on: { paste: _vm.handlePaste } }, [
                      _c("input", {
                        staticClass: "pasteInput",
                        attrs: {
                          type: "text",
                          placeholder: "粘贴截图上传",
                          maxlength: "0",
                        },
                      }),
                    ]),
                    _c(
                      "el-button",
                      {
                        staticClass: "el-icon-upload importFile",
                        staticStyle: { "margin-left": "10px" },
                        attrs: {
                          disabled:
                            _vm.ruleForm.file && _vm.ruleForm.file.length >= 9,
                          type: "primary",
                        },
                        on: { click: _vm.uploadFile },
                      },
                      [
                        _vm._v(
                          "上传设计稿(" +
                            _vm._s(
                              _vm.ruleForm.file ? _vm.ruleForm.file.length : 0
                            ) +
                            "/9)"
                        ),
                      ]
                    ),
                    _vm.$hasBtnRoles("/cardmake/card/down-design-draft") &&
                    _vm.formType === "printing"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "el-icon-download importFile",
                            attrs: { type: "success" },
                            on: { click: _vm.downFile },
                          },
                          [_vm._v("下载设计稿 ")]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          color: "#909399",
                          "margin-left": "10px",
                        },
                      },
                      [
                        _vm._v(
                          " 设计稿支持上传JPGE、JPG、PNG、PSD、PDF、ai 格式的文件 "
                        ),
                      ]
                    ),
                    _c("div", { staticStyle: { position: "relative" } }, [
                      _vm.ruleForm.file.some(function (item) {
                        return _vm.isImage(item)
                      })
                        ? _c(
                            "div",
                            { staticClass: "img-style2" },
                            _vm._l(
                              _vm.ruleForm.file.filter(function (el) {
                                return _vm.isImage(el)
                              }),
                              function (item, indexs) {
                                return _c(
                                  "div",
                                  {
                                    key: "img-" + indexs,
                                    staticClass: "img-style2-con",
                                  },
                                  [
                                    _c("el-image", {
                                      staticStyle: {
                                        height: "50px",
                                        width: "70px",
                                      },
                                      attrs: {
                                        src: item,
                                        fit: "cover",
                                        "preview-src-list":
                                          _vm.ruleForm.file.filter(function (
                                            el
                                          ) {
                                            return _vm.isImage(el)
                                          }),
                                      },
                                    }),
                                    _c("i", {
                                      staticClass: "el-icon-circle-close close",
                                      on: {
                                        click: function ($event) {
                                          _vm.delStyleImage(
                                            _vm.getOriginalIndex(item)
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm.ruleForm.file.some(function (item) {
                        return !_vm.isImage(item)
                      })
                        ? _c(
                            "div",
                            { staticClass: "file-list" },
                            _vm._l(
                              _vm.ruleForm.file.filter(function (el) {
                                return !_vm.isImage(el)
                              }),
                              function (item, indexs) {
                                return _c(
                                  "div",
                                  {
                                    key: "file-" + indexs,
                                    staticClass: "file-item",
                                  },
                                  [
                                    _c("div", { staticClass: "file-info" }, [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-document file-icon",
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "file-name",
                                          class: {
                                            "pdf-file": _vm.isPdf(item),
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.isPdf(item) &&
                                                _vm.openFile(item)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.getFileName(item)))]
                                      ),
                                    ]),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-circle-close file-close",
                                      on: {
                                        click: function ($event) {
                                          _vm.delStyleImage(
                                            _vm.getOriginalIndex(item)
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveFile } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("upload-file", {
        ref: "uploadBanner",
        staticStyle: { display: "none" },
        attrs: {
          onlyImg: false,
          "link-url": _vm.linkUrl,
          limit: 9,
          multiple: true,
        },
        on: { emitUploadFile: _vm.emitUploadFile },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }